/**
 * EB 壳开关（独立文件，避免 permission ↔ router 循环依赖）
 */
export const useCrmebShell = import.meta.env.VITE_USE_CRMEB_SHELL !== 'false';
